<template>
    <st-modal
        ref="st-edit-tax-category-modal"
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('TAX_CATEGORY.FORM.EDIT_TITLE')"
    >
        <template #body>
            <tax-category-form
                @cancel="hide"
                @submit="submit"
                :item="selectedItem"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('GENERAL.BUTTON.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('GENERAL.BUTTON.SAVE') }}
                        </st-button>
                    </div>
                </template>
            </tax-category-form>
        </template>
    </st-modal>
</template>

<script>
import TaxCategoryForm from './TaxCategoryForm.vue';

export default {
    name: 'EditTaxCategoryModal',
    components: {
        TaxCategoryForm,
    },
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-edit-tax-category-modal'].show();
        },
        hide() {
            this.$refs['st-edit-tax-category-modal'].hide();
        },
        submit(item) {
            this.$emit('submit', item);
        },
    },
}
</script>